import { Component, OnInit, DoCheck, KeyValueDiffers } from '@angular/core';
import { FileSelectDirective, FileDropDirective, FileUploader, FileLikeObject, FileItem } from 'ng2-file-upload/ng2-file-upload';
import { UploadService, Region, Country, City, LatLng, Tax, Device } from './upload.service';
import { PreviewComponent } from '../../components/preview/preview.component';
import { FormErrors } from "../login/auth.service";

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Renderer2 } from '@angular/core';
import { Pagination } from '../../helpers/pagination';
import { IMultiSelectSettings, IMultiSelectTexts, IMultiSelectOption } from 'angular-2-dropdown-multiselect';

import { NgbDateStruct, NgbCalendar, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { environment } from '../../../environments/environment';
import { TargetAd } from './target-ad.component';
import { BadFile } from './badfile';
import { AdForm, CardData } from './adform';

declare var csf: any;

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  providers: [UploadService],
})

export class UploadPage implements OnInit, DoCheck {

  // definition of allowed number, image and video type, file size, duration in sec
  public uploaderSettings = {
      url: '/',
      queueLimit: 3,
      allowedMimeType: ['image/jpg', 'image/jpeg', 'video/mp4'],
      maxFileSize:  100*1024*1024, //100MB
      duration: 60,
  };

  public uploader: FileUploader = new FileUploader(this.uploaderSettings);

  public modalRegions: Array<Region>;
  public modalDevices: Array<Device>;
  public staticMode: boolean = true;
  public uploaded: boolean;
  public currentPreview: number = 0;
  private cycleTimer: any;
  public images: number = 0;
  public videos: number = 0;
  public errors: FormErrors = new FormErrors;
  differ: any;
  public step: number = 1;
  public countries: Array<Country> = [];

  public country_id: number = null;
  public city_id: number = null;
  public country: Country;
  public city: City;
  public uploading: any;
  public devicesLoading: boolean = false;

  public paths: Array<LatLng> = [];
  public regionSelected: boolean = false;
  public activeRegion: any;//TODO: class
  public activeDevice: any;//TODO: class
  public schedules: Array<any> = [];
  public deviceSchedules: Array<any> = [];
  public slotSelectionMode: boolean = true;
  public dateSelectionMode: boolean = true;
  public before = before;
  public after = after;
  public equals = equals;
  private previewPaused: boolean = false;

  public hover = {
    region: null,
    coords: null,
    timeout: null,
    zoom: 17,
    hint: false,

    zoomChanged: function(zoom) {
      if (this.coords) {
        var latShift = 5 / (1 << this.zoom);
        this.zoom = zoom;
        this.coords.lat += 5 / (1 << this.zoom) - latShift;
      } else {
        this.zoom = zoom;
      }
    }
  };

  public badFiles: Array<BadFile> = [];

  public minDate: NgbDateStruct;
  public maxDate: NgbDateStruct;
  public pagination: Pagination = new Pagination([]);

  public selectedDates: Array<NgbDateStruct> = [];

  public mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block multiple-dropdown',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: false,
    fixedTitle: false,
    selectionLimit: 1,
    closeOnSelect: true,
    autoUnselect: true,
  }

  public ad: AdForm = new AdForm();
  public regionsNames: string;
  public devicesNames: string;
  public months: Array<any> = [];
  public years: Array<any> = [];
  public taxes: Array<Tax> = [];
  public tax: Tax;
  public invoiceStatus: number = 0;
  private deviceCount: number = 0;
  public orientation_set: string = 'horizontal';

  public invoiceStatuses = {
    none: 1,
    pending: 2,
    rejected: 3,
    approved: 4
  };

  public mouseDownDateTimer: any = null;

  private cardFormInititalized: boolean = false;
  public focused: any = null;

  public activeIds
  public targetAds: Array<TargetAd> = [];

  private targetAdMaxCount: number = 2;

  public selectedMaleAgeGroups: number[] = [-1,-1,-1,-1,-1,-1,-1,-1,-1];
  public selectedFemaleAgeGroups: number[] = [-1,-1,-1,-1,-1,-1,-1,-1,-1];



  constructor(private toastyService: ToastyService, public uploadService: UploadService, private differs: KeyValueDiffers, private modalService: NgbModal, private router: Router, calendar: NgbCalendar, private renderer: Renderer2) {

    var instance = this;
    this.uploader.onWhenAddingFileFailed = function(item, filter, options) {
      instance.badFiles.push(new BadFile(item, filter));
    };

    this.uploader.onAfterAddingFile = function(fileItem) {
      if (/video\/*/.test(fileItem.file.type)) {
        instance.uploader.removeFromQueue(fileItem);
        var obj = document.createElement('video');
        obj.preload = 'metadata';

        obj.onloadedmetadata = function() {
          if (Math.floor(obj.duration) > instance.uploaderSettings.duration) {
            instance.badFiles.push(new BadFile(fileItem.file, {name: "duration"}));
          } else {
            instance.uploader.queue.push(fileItem);
          }
        };
        obj.src = URL.createObjectURL(fileItem._file);    
      }
    };

    this.minDate = calendar.getPrev(calendar.getToday());
    this.maxDate = calendar.getNext(calendar.getToday(), 'd', 366);

    this.differ = differs.find({}).create(null);

    this.uploadService.geo().then(result => {
      result.forEach((country, index, countries) => {
        country.cities.forEach((city, index, cities) => {
          city.regions.forEach((region, index, regions) => {
            regions[index] = Object.assign(new RegionDisplay, region);
          });
        });
      });
      // sort alphabetically countries
      result.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 
      this.countries = result;
    });

    this.uploadService.taxes().then(result => {
      this.taxes = result;
      this.taxes.forEach(t => t.name = t.country);
    });

    this.uploadService.getInvoiceStatus().then(result => {
      this.invoiceStatus = result;
    });

    let year = (new Date()).getFullYear();
    for (let d=0; d < 10; d++) {
      this.years.push({id: year+d, name: (year+d).toString().substr(-2)});
    }

    for (let m=1; m <= 12; m++) {
      this.months.push({id: m, name: this.padLeft(m.toString(), '0', 2)});
    }
  }

  checkMaleAgeDisabled(i, targetIndx) {
    for (let j = 0; j < this.targetAds.length; j++) {
      if (j == targetIndx) continue
      if (this.targetAds[j].maleAgeGroups[i].selected) return true
    }
    return false
  }

  checkFemaleAgeDisabled(i, targetIndx) {
    for (let j = 0; j < this.targetAds.length; j++) {
      if (j == targetIndx) continue
      if (this.targetAds[j].femaleAgeGroups[i].selected) return true
    }
    return false
  }

  addTargetComponent(acc) {
    this.targetAds.push(
      new TargetAd(this.differs, this.uploaderSettings)
    )

    acc.activeIds="targetAd-"+(this.targetAds.length-1);
  }

  deleteTargetAd(acc, id) {
    this.targetAds.splice(id, 1);
    if (id - 1 < 0) {
      acc.activeIds="default-ad";
    } else {
      acc.activeIds="targetAd-" + (id - 1);
    }
  }

  activeAdTab(acc) {
    return acc.activeIds
  }

  public beforeChange($event: NgbPanelChangeEvent) {
    if ($event.panelId === 'default-ad' && this.targetAds.length == 0) {
      $event.preventDefault();
    }
  };

  warning() {
    return !this.errors.isEmpty() && (this.emptyAdName() || this.emptyFiles())
  }

  emptyFiles() {
    return this.uploader.queue.length == 0
  }

  emptyAdName() {
    return !this.ad.name || (this.ad.name && this.ad.name.replace(/\s/g, '') == '')
  }

  similarTargetNames() {
    const filteredArr = this.targetAds.filter((item) => {
      return item.title !== undefined
    })
    const resArr = filteredArr.reduce((res, item) => {
      var title = item.title.trim().toLowerCase();
      if (res.indexOf(title) === -1) {
        res.push(title)
      }
      return res
    }, [])
    return resArr.length !== filteredArr.length
  }

  private padLeft(text:string, padChar:string, size:number): string {
      return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
  }

  private formatDate(date: NgbDateStruct): string {
    return date.year.toString()+"-"+this.padLeft(date.month.toString(), '0', 2)+"-"+this.padLeft(date.day.toString(), '0', 2);
  }

  onMouseDownSlot($event, slot) {
    if (($event.buttons == undefined? $event.which : $event.buttons)) {
      this.toggleSlot(slot);
      this.slotSelectionMode = slot.selected == true;
    }
  }

  isDateSelected(date: NgbDateStruct) {
    return this.selectedDates.findIndex(it => equals(it, date)) != -1;
  }

  onMouseDownDate($event, date: NgbDateStruct) {
    if (($event.buttons == undefined? $event.which : $event.buttons) && after(date, this.minDate) && before(date, this.maxDate)) {
      let index = this.selectedDates.findIndex(it => equals(it, date));
      if (index >=0) {
        this.selectedDates.splice(index, 1);
        this.dateSelectionMode = false;
      } else {
        this.selectedDates.push(date);
        this.dateSelectionMode = true;
      }
      if (this.mouseDownDateTimer) {
        clearTimeout(this.mouseDownDateTimer);
      }
      this.mouseDownDateTimer = setTimeout(()=>{
        this.onMouseUpDate(null, null);
      }, 100);
    }
  }

  onMouseUpDate($event, date: NgbDateStruct) {
    if (this.mouseDownDateTimer) {
      clearTimeout(this.mouseDownDateTimer);
    }

    if (this.selectedDates.length) {
      let dates: Array<string> = [];
      this.selectedDates.forEach(date => {
        dates.push(this.formatDate(date));
      });

      this.uploadService.getTimeslots(dates, this.getSelectedRegions(), this.getSelectedDevices()).then(result => {
        /*this.schedules = result.regions;
        let item = this.schedules[0];
        if (!item.pagination) {
          item.pagination = new Pagination(item.schedule);
        }
        this.activeRegion = item;*/
        //this.pagination = new Pagination(this.activeRegion.schedule);
        this.deviceCount = result.deviceCount;
        let newSchedules = result.regions;

        newSchedules.forEach(item => {
          let oldSchedule = this.getScheduleFor(item.id);
          if (oldSchedule) {
            item.schedule.forEach( newDay => {
              oldSchedule.forEach( oldDay => {
                if (oldDay.date == newDay.date) {
                  oldDay.timeslots.forEach((slot, slotIndex) => {
                    if (!slot.not_available && slot.selected && newDay.timeslots[slotIndex] && !newDay.timeslots[slotIndex].not_available) {
                      newDay.timeslots[slotIndex].selected = true;
                    }
                  });
                }
              });
            });
          }
        });
        this.schedules = newSchedules;

        let newDeviceSchedules = result.devices;

        newDeviceSchedules.forEach(item => {
          let oldSchedule = this.getDeviceScheduleFor(item.id);
          if (oldSchedule) {
            item.schedule.forEach( newDay => {
              oldSchedule.forEach( oldDay => {
                if (oldDay.date == newDay.date) {
                  oldDay.timeslots.forEach((slot, slotIndex) => {
                    if (!slot.not_available && slot.selected && newDay.timeslots[slotIndex] && !newDay.timeslots[slotIndex].not_available) {
                      newDay.timeslots[slotIndex].selected = true;
                    }
                  });
                }
              });
            });
          }
        });
        this.deviceSchedules = newDeviceSchedules;
        
        if (this.schedules.length) {
          if (!this.activeRegion) {
            this.activateRegion(this.schedules[0]);
          } else {
            this.activateRegion(this.activeRegion);
          }
        } else {
          if (!this.activeDevice) {
            this.activateDevice(this.deviceSchedules[0]);
          } else {
            this.activateDevice(this.activeDevice);
          }
        }
        this.recalcCost();
      });

    } else {
      this.schedules = [];
      this.deviceSchedules = [];
      this.activeRegion = null;
      this.activeDevice = null;
    }
  }

  onMouseOverDate($event, date) {
    if ( ($event.buttons == undefined? $event.which : $event.buttons) && after(date, this.minDate) && before(date, this.maxDate)) {
      let index = this.selectedDates.findIndex(it => equals(it, date));

      if (index >=0) {
        if (!this.dateSelectionMode) {
          this.selectedDates.splice(index, 1);
        }
      } else {
        if (this.dateSelectionMode) {
          this.selectedDates.push(date);
        }
      }

      if (this.mouseDownDateTimer) {
        clearTimeout(this.mouseDownDateTimer);
      }
      this.mouseDownDateTimer = setTimeout(()=>{
        this.onMouseUpDate(null, null);
      }, 300);
    }
  }

  onMouseOverSlot($event, slot) {
    if (($event.buttons == undefined? $event.which : $event.buttons) && !slot.not_available) {
      slot.selected = this.slotSelectionMode;
      this.recalcCost();
    }
  }

  onDragStart($event, item) {
    this.pausePreview();
  }

  onDragEnd($event, item) {
    item.top = $event.top;
    item.bounds = $event.bounds;
    this.resumePreview();
  }

  selectAll() {
    if (!this.activeRegion && !this.activeDevice) return;
    let active = (this.activeRegion ? this.activeRegion : this.activeDevice);

    active.schedule.forEach(day => {
      day.timeslots.forEach(timeslot => {
        if (!timeslot.not_available) {
          timeslot.selected = active.selectAll;
        }
      })
    });
    this.recalcCost();
  }

  ngOnInit() {
    window.onbeforeunload = function (e) {
      e = e || window.event;
      // For IE and Firefox prior to version 4
      if (e) {
          e.returnValue = 'Any string';
      }
      // For Safari
      return 'Any string';
  };
  }

  log(something: any) {
    console.log(something);
  }

  private getSelectedRegions(withSchedule: boolean = false): Array<any> {
    let selectedRegions = [];
    if (this.city) {
      this.city.regions.forEach(region => {
        if ((<RegionDisplay>region).isSelected()) {
          selectedRegions.push({id: region.id, name: region.name, schedule: withSchedule ? this.getScheduleFor(region.id) : null });
        }
      });
    }
    return selectedRegions;
  }

  private getSelectedDevices(withSchedule: boolean = false): Array<any> {
    let selectedDevices = [];
    if (this.city) {
      this.city.devices.forEach(device => {
        if (device.selected) {
          selectedDevices.push({id: device.id, name: device.name, schedule: withSchedule ? this.getDeviceScheduleFor(device.id) : null });
        }
      });
    }
    return selectedDevices;
  }

  private getScheduleFor(regionId: number) {
    let schedule;
    this.schedules.forEach(item => {
      if (item.id == regionId) {
        schedule = item.schedule;
      }
    });
    return schedule;
  }

  private getDeviceScheduleFor(deviceId: number) {
    let schedule;
    this.deviceSchedules.forEach(item => {
      if (item.id == deviceId) {
        schedule = item.schedule;
      }
    });
    return schedule;
  }

  public upload() {
    this.uploaded = null;
    this.errors.clear();

    this.targetAds.forEach(targetAd => {
      targetAd.errors.clear();
    });

    switch (this.step) {
      case 3:
        if (this.ad.pay_with == 'invoice' && this.invoiceStatus != this.invoiceStatuses.approved) {
          this.errors.add({field: "invoice", type: "not_available"});
        }

        if (!this.ad.agree) {
          this.errors.add({field: "agree", type: "required"});
        }

        if (this.ad.pay_with == 'card') {
          if (!this.ad.card_data.holderName) {
            this.errors.add({field: "card_name", type: "required"});
          }
          if (!this.ad.card_data.encryptedCardNumber) {
            this.errors.add({field: "card_number", type: "invalid"});
          }
          if (!this.ad.card_data.encryptedExpiryMonth) {
            this.errors.add({field: "card_month", type: "invalid"});
          }
          if (!this.ad.card_data.encryptedExpiryYear) {
            this.errors.add({field: "card_year", type: "invalid"});
          }
          if (!this.ad.card_data.encryptedSecurityCode) {
            this.errors.add({field: "card_cvv", type: "invalid"});
          }
          if (!this.ad.tax) {
            this.errors.add({field: "tax", type: "required"});
          }
        }

        /*if (this.ad.pay_with == 'invoice') {
            if (this.ad.company_name.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_name", type: "required"});
            }
            if (this.ad.company_vat.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_vat", type: "required"});
            }
            if (this.ad.company_address.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_address", type: "required"});
            }
            if (this.ad.company_zip.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_zip", type: "required"});
            }
            if (this.ad.company_city.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_city", type: "required"});
            }
            if (this.ad.company_country.replace(/\s/g,"") == "") {
              this.errors.add({field: "company_country", type: "required"});
            }
        }*/
      case 2:
        let regionsWitchSelectedTimeslots = this.getRegionsWitchSelectedTimeslots();
        let devicesWitchSelectedTimeslots = this.getDevicesWitchSelectedTimeslots();

        if (!regionsWitchSelectedTimeslots.length && !devicesWitchSelectedTimeslots.length) {
          this.errors.add({field: "timeslots", type: "not_selected"});
        } else {
          this.ad.regions = regionsWitchSelectedTimeslots;
          this.ad.devices = devicesWitchSelectedTimeslots;
          this.regionsNames = regionsWitchSelectedTimeslots.map(x=>x.name).join(", ");
          this.devicesNames = devicesWitchSelectedTimeslots.map(x=>x.name).join(", ");
        }

        if (!this.ad.budget) {
          //this.errors.add({field: "budget", type: "required"});
        }

        if (this.ad.budget && this.ad.budget < 10) {
          this.errors.add({field: "budget", type: "min"});
        }

      case 1:
        // check files in queue
        if (this.emptyFiles()) {
           this.errors.add({field: "files", type: "required"});
        }

        // check AD name in form
        if (this.emptyAdName()) {
          this.errors.add({field: "name", type: "required"});
        }

        this.targetAds.forEach(targetAd => {
          if (targetAd.title !== undefined && targetAd.title.trim().toLowerCase() == "default") {
            targetAd.errors.add({field:"title", type:"default"});
          }

          // Check target files
          if (targetAd.emptyFiles()) {
            targetAd.errors.add({field: "files", type: "required"});
          }

          // check target names in form
          if (targetAd.emptyTitle()) {
            console.log("Target ad title should be not empty");
            targetAd.errors.add({field: "title", type: "required"});
          }

          // check target group by empty
          if (targetAd.emptyTargetGroup()) {
            targetAd.errors.add({field: "target", type: "required"});
          }
        });

       // check target names duplicat in form
       if (this.similarTargetNames()) {
        this.targetAds.forEach(targetAd => {
          targetAd.errors.add({field:"title", type:"similar"});
        });
       }

        // check AD name as duplicat in DB
        if (this.ad.name && this.ad.name.replace(/\s/g, '') != '') {
          this.uploadService.check(this.ad.name).then(
            success => {
              if (!success) {
                this.errors.add({field: "name", type: "inuse"});
              }
              if (this.errors.isEmpty() && this.step < 3) {
                var errInTarget: boolean = false;

                this.targetAds.forEach(targetAd => {
                  if (!targetAd.errors.isEmpty()) {
                    errInTarget = true;
                  }
                });

                if (!errInTarget) {
                  this.step++;
                }
              }

              if (this.step == 3) {
                this.startPreview();

                if (!this.cardFormInititalized) {
                  setTimeout(() => this.form(), 1000);
                }
              }
            }
          );
        }
    }

    if (this.errors.isEmpty() && this.step == 3) {
      let ad = JSON.parse(JSON.stringify(this.ad));
      if (!ad.budget) {
        ad.budget = Math.floor(ad.maxCost);
        if (ad.maxCost < 1.00) { ad.budget = 1; }
      }

      ad.orientation = this.orientation_set;

      var targetQueues: Array<FileItem[]> = [];

      this.targetAds.forEach((targetAd, i) => {
        targetQueues.push(targetAd.uploader.queue);

        ad.targetInfo.push({
          index: i,
          title: targetAd.title,
          target_group: {
            male: targetAd.maleAgeGroups.filter(ag => ag.selected),
            female: targetAd.femaleAgeGroups.filter(ag => ag.selected)
          }
        })
      });

      this.uploading = this.uploadService.upload(ad, this.uploader.queue, this.orientation_set, targetQueues)
        .then(result => {
          this.uploaded = result;
          if (this.uploaded) {
            this.router
            .navigate(['dashboard']);
            //.then(() => {window.location.reload();});

            let toastOptions:ToastOptions = {
              title: null,
              msg: "Thanks for submitting your ad, we will review it within the next 24 hours and notify you if the ad was approved or rejected",
              timeout: 10000,
              theme: 'bootstrap',
              showClose: true,
            };
            this.toastyService.success(toastOptions);
          }
        }, err => {
          this.uploaded = false;
          this.uploading = false;

          let msg:string = "Please fill all required fields correctly";

          if (err.statusText == "") {
            msg = "Network error. Please try again";
          } else {
            err = err.json();

            if (err.error.code == "payment_method_not_supported") {
              this.errors.add({field: "form", type: "payment_method_not_supported"})
            }

            if (this.errors.has('name', 'inuse')) {
              msg = "Ad with such name already exists";
            }
            if (this.errors.has('form', 'payment_method_not_supported')) {
              msg = "Payment method selected is not available for now, please choose another";
            }

            if (err.error.code == "banned") {
              msg = "You are banned";
            }
          }

          let toastOptions:ToastOptions = {
            title: null,
            msg: msg,
            timeout: 5000,
            theme: 'bootstrap',
            showClose: true,
          };
          this.toastyService.error(toastOptions);
        });
    }

    if (this.errors.isEmpty() && this.step == 2) {
      this.uploadService.getInvoiceStatus().then(result => {
        this.invoiceStatus = result;
      });
    }
  }

  public form() {
    let styleObject = {
      base: {
        fontSmoothing: 'antialiased',
        fontFamily: 'Helvetica',
        lineHeight: '18px',
        color: '#5e5e5e',
        fontWeight: 600,
        fontSize: '14px',
      },
      error: {
        color: '#d9534f'
      },
      placeholder: {
        fontWeight: 200,
        color: '#d8d8d8'
      },
      validated: {
        //color: 'green'
      }
    };


    let csfSetupObj = {
      rootNode: '.pay-with-card',
      configObject : {
        originKey : environment.adyen.apiKey
      },
      paymentMethods : {
        card : {
          sfStyles : styleObject,
        }
      }
    };
    let securedFields = csf(csfSetupObj);


    securedFields.onFieldValid((fieldObject) => {
      if (fieldObject.valid) {
        this.ad.card_data[fieldObject.encryptedFieldName] = fieldObject.blob;
      } else {
        this.ad.card_data[fieldObject.encryptedFieldName] = "";
      }
    });

    securedFields.onFocus((focusObject) => {
      if (focusObject.focus) {
        this.focused = focusObject.fieldType;
      } else {
        this.focused = null;
      } 
    });

    this.cardFormInititalized = true;
  }

  private getRegionsWitchSelectedTimeslots() {
    let regions = this.getSelectedRegions(true);

    let regionsWitchSelectedTimeslots: Array<any> = [];
    regions.forEach(region => {
      let hasSelection = false;
      if (region.schedule) {
        region.schedule.forEach(date => {
          let dateHasSelection = false;
          date.timeslots.forEach(slot => {
            if (slot.selected) {
              hasSelection = true;
              dateHasSelection = true;
            }
          });
          date.hasSelection = dateHasSelection;
          date.timeslotsAsString = this.timeslotsToString(date.timeslots);
        });
      }
      if (hasSelection) {
        regionsWitchSelectedTimeslots.push(region);
      }
    });
    return regionsWitchSelectedTimeslots
  }

  private getDevicesWitchSelectedTimeslots() {
    let devices = this.getSelectedDevices(true);

    let devicesWitchSelectedTimeslots: Array<any> = [];
    devices.forEach(device => {
      let hasSelection = false;
      if (device.schedule) {
        device.schedule.forEach(date => {
          let dateHasSelection = false;
          date.timeslots.forEach(slot => {
            if (slot.selected) {
              hasSelection = true;
              dateHasSelection = true;
            }
          });
          date.hasSelection = dateHasSelection;
          date.timeslotsAsString = this.timeslotsToString(date.timeslots);
        });
      }
      if (hasSelection) {
        devicesWitchSelectedTimeslots.push(device);
      }
    });
    return devicesWitchSelectedTimeslots
  }

  public activateRegion(region: Region) {
    this.schedules.forEach(item => {
      if (item.id == region.id) {
        if (!item.pagination) {
          item.pagination = new Pagination(item.schedule);
        }
        this.activeDevice = null;
        this.activeRegion = item;
      }
    });
  }

  public activateDevice(device: Device) {
    if (device) {
      this.deviceSchedules.forEach(item => {
        if (item.id == device.id) {
          if (!item.pagination) {
            item.pagination = new Pagination(item.schedule);
          }
          this.activeRegion = null;
          this.activeDevice = item;
        }
      });
    }
  }

  public removeRegion(region: Region, $event) {
      $event.stopPropagation();
      (<RegionDisplay>region).toggleSelection();
      this.checkIfActiveRegionRemoved();
      this.recalcCost();
  }

  public removeDevice(device: Device, $event) {
    $event.stopPropagation();
    device.selected = false;
    this.checkIfActiveRegionRemoved();
    this.recalcCost();
}

  public checkIfActiveRegionRemoved() {
    if (!this.activeRegion && !this.activeDevice) {
      return false;
    }
    let firstSelectedRegion = null;
    let currentActiveIsSelected = false;

    this.city.regions.forEach(region => {
      if ((<RegionDisplay>region).isSelected()) {
        if (!firstSelectedRegion) {
          firstSelectedRegion = region;
        }
        if (this.activeRegion && this.activeRegion.id == region.id) {
          currentActiveIsSelected = true;
        }
      }
    });

    let firstSelectedDevice = null;

    this.city.devices.forEach(device => {
      if (device.selected) {
        if (!firstSelectedDevice) {
          firstSelectedDevice = device;
        }
        if (this.activeDevice && this.activeDevice.id == device.id) {
          currentActiveIsSelected = true;
        }
      }
    });

    if (!firstSelectedRegion && !firstSelectedDevice) {
      this.clearTimeslots();
    } else {
      if(!currentActiveIsSelected) {
        if (firstSelectedRegion) {
          this.activateRegion(firstSelectedRegion);
        } else {
          this.activateDevice(firstSelectedDevice);
        }
      } 
    }
  }

  public toggleSlot(slot: any) {
    if (!slot.not_available) {
      slot.selected = !slot.selected;
      (this.activeRegion ? this.activeRegion : this.activeDevice).selectAll = false;
      this.recalcCost();
      if (slot.selected && this.errors.has('timeslots', 'not_selected')) {
        this.errors.remove('timeslots', 'not_selected');
      } 
    }
  }

  public validationFailed(): boolean {
    switch (this.step) {
      case 1:
        return (this.videos > 0 && this.images > 0) || this.videos > 1;

      case 2:
        let selectedRegions = 0;
        if (this.city && (this.city.regions.length || this.city.devices.length)) {
          if (this.city.regions.length) {
            this.city.regions.forEach(region => {
              if ((<RegionDisplay>region).isSelected()) {
                selectedRegions++;
              }
            });
          } 
          if (this.city.devices.length) {
            this.city.devices.forEach(device => {
              if (device.selected) {
                selectedRegions++;
              }
            });
          }
        }
        return !this.selectedDates.length || selectedRegions == 0 || this.uploading || this.uploader.queue.length == 0 || !this.ad.name || (this.ad.name && this.ad.name.replace(/\s/g, '') == '')  || (this.videos > 0  && this.images > 0) || this.videos > 1;
      case 3:
        return false;

      default:
       return false;
    }

  }

  public startPreview() {
    if (this.previewPaused) return;

    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
      this.currentPreview = 0;
    }
    let instance = this;
    this.cycleTimer = setInterval(function(){
      instance.currentPreview = (instance.currentPreview+1)%instance.uploader.queue.length;
    }, 2000);
  }

  public previewUnavailable()
  {
    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
      this.currentPreview = 0;
    }
  }

  public pausePreview()
  {
    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
    }
  }

  public resumePreview()
  {
    if (this.cycleTimer) {
      clearInterval(this.cycleTimer);
    }
    
    let instance = this;
    this.cycleTimer = setInterval(function(){
      instance.currentPreview = (instance.currentPreview+1)%instance.uploader.queue.length;
    }, 2000);
  }

  ngDoCheck() {
    var changes = this.differ.diff(this.uploader.queue);
    if(changes) {
      this.checkPreview(this)
    }

    this.targetAds.forEach(target => {
      var tChanges = target.differ.diff(target.uploader.queue);
      if(tChanges) {
        this.checkPreview(target)
      }
    });
  }

  private checkPreview(instance) {
      instance.images = 0;
      instance.videos = 0;
      instance.uploader.queue.forEach(item => {
        if(/image/i.test(item._file.type)) {
          instance.images++;
        }
        if(/video/i.test(item._file.type)) {
          instance.videos++;
        }
      });
      if (instance.images && instance.videos) {
        instance.previewUnavailable();
      } else {
        instance.startPreview();
      }
  }

  public back() {
    this.step = Math.max(0, this.step - 1);
  }

  public open(content) {
    this.hover.region = null;
    this.hover.coords = null;
    this.modalRegions = this.city.regions.map(x => Object.assign(new RegionDisplay, x));
    this.modalDevices = Object.assign([], this.city.devices);
    this.staticMode = true;

    this.modalService.open(content, {size: "lg", backdrop: "static"}).result.then((result) => {
      if (result == 'confirm') {

        let selectedRegions: number = 0;
        this.city.regions = this.modalRegions.map(x => {

          var region = Object.assign(new RegionDisplay, x);
          if (region.isSelected()) {
            selectedRegions++;
          }
          return region;
        });

        this.city.devices = this.modalDevices.map(x => {
          if (x.selected) {
            selectedRegions++;
          }
          return x;
        });   

        this.regionSelected = selectedRegions > 0;

        if (this.selectedDates.length) {
          //this.checkIfActiveRegionRemoved();
          let dates: Array<string> = [];
          this.selectedDates.forEach(date => {
            dates.push(this.formatDate(date));
          });

          this.uploadService.getTimeslots(dates, this.getSelectedRegions(), this.getSelectedDevices()).then( result => {
            this.deviceCount = result.deviceCount;
            let newSchedules = result.regions;
            newSchedules.forEach(item => {
              let oldSchedule = this.getScheduleFor(item.id);
              if (oldSchedule) {
                oldSchedule.forEach((day, dayIndex)=>{
                  day.timeslots.forEach((slot, slotIndex)=>{
                    if (!slot.not_available && slot.selected && item.schedule[dayIndex].timeslots[slotIndex] && !item.schedule[dayIndex].timeslots[slotIndex].not_available) {
                      item.schedule[dayIndex].timeslots[slotIndex].selected = true;
                    }
                  });
                });
              }
            });
            this.schedules = newSchedules;

            let newDeviceSchedules = result.devices;
            newDeviceSchedules.forEach(item => {
              let oldSchedule = this.getDeviceScheduleFor(item.id);
              if (oldSchedule) {
                oldSchedule.forEach((day, dayIndex)=>{
                  day.timeslots.forEach((slot, slotIndex)=>{
                    if (!slot.not_available && slot.selected && item.schedule[dayIndex].timeslots[slotIndex] && !item.schedule[dayIndex].timeslots[slotIndex].not_available) {
                      item.schedule[dayIndex].timeslots[slotIndex].selected = true;
                    }
                  });
                });
              }
            });
            this.deviceSchedules = newDeviceSchedules;

            this.checkIfActiveRegionRemoved();
            this.recalcCost();
          });
        }
      }
    }, (reason) => {
      console.log(`Dismissed ${reason}`);
    });
  }

  public clearTimeslots() {
    this.regionSelected = false;
    this.selectedDates = [];
    this.schedules = [];
    this.activeRegion = null;
    this.activeDevice = null;
    this.recalcCost();
  }

  public polyMouseMove($event, region) {
    this.hover.region = region;
    this.hover.hint = false;

    if (this.hover.timeout) {
      clearTimeout(this.hover.timeout);
    }

    this.hover.timeout = setTimeout(() =>{
      this.hover.coords = {
        lat: $event.latLng.lat() + 5 / (1 << this.hover.zoom),
        lng: $event.latLng.lng()
      };
      this.hover.hint = true;
    }, 100);
  }

  public polyMouseOut($event) {
    this.hover.hint = false;
    if (this.hover.timeout) {
      clearTimeout(this.hover.timeout);
    }
  }

  public onCountryChanged() {
    this.country = this.countries.filter(c => c.id == this.country_id)[0];
    this.city = null;
    this.city_id = null;
    this.clearTimeslots();
  }

  public onCityChanged() {
    if (this.city_id) {
      this.devicesLoading = true;
      this.uploadService.devices({city_id: this.city_id}).then((devices)=>{
        this.city = this.country.cities.filter(c => c.id == this.city_id)[0];
        this.city.devices = devices;
        this.devicesLoading = false;
      })
    }
    this.clearTimeslots();
  }

  public onTaxChange(tax_id: number) {
    this.ad.tax = tax_id;
    this.updateDisplayVat();
  }

  public onPaymentMethodChange() {
    this.updateDisplayVat();
  }

  public onMarkerClick(device: Device) {
    device.selected = !device.selected
  }

  private updateDisplayVat() {
      switch (this.ad.pay_with) {
        case "invoice":
          this.tax = null;
          break;
        case "card":
          if(this.ad.tax && this.ad.company_vat.replace(/\s/g, '') == '') {
            this.tax = this.taxes.filter(t => t.id == this.ad.tax)[0];
          } else {
            this.tax = null;
          }
          break;
      }
  }

  public onEUVatChange() {
    this.updateDisplayVat();
  }

  // cost calculator when selecting timeslots in calendar update page
  private recalcCost() {
    let cost = 0;

    let regionsWitchSelectedTimeslots = this.getRegionsWitchSelectedTimeslots();
    regionsWitchSelectedTimeslots.forEach(region => {
      region.schedule.forEach(day => {
        if (day.hasSelection) {
          day.timeslots.forEach(slot => {
            if (!slot.not_available && slot.selected) {
              cost += slot.price * this.deviceCount * 60;
            }
          });
        }
      });
    });
    
    let devicesWitchSelectedTimeslots = this.getDevicesWitchSelectedTimeslots();
    devicesWitchSelectedTimeslots.forEach(device => {
      device.schedule.forEach(day => {
        if (day.hasSelection) {
          day.timeslots.forEach(slot => {
            if (!slot.not_available && slot.selected) {
              cost += slot.price * 60;
            }
          });
        }
      });
    });
    this.ad.maxCost = Math.round(cost*100)/100;
    if (this.ad.budget && this.ad.budget < this.ad.maxCost) {
      this.ad.maxCost = this.ad.budget
    }

    this.ad.potentialCost = Math.round(0.35 * this.ad.maxCost * 100)/100;
  }

  public timeslotsToString(timeslots: Array<any>) {
    let bounds = ['00','01','02','03','04','05','06','07','08','09',10,11,12,13,14,15,16,17,18,19,20,21,22,23,'00'];

    let mergeIntervals = function(intervals): Array<any>
    {

      let stack = [], last;
      if (intervals.length) {
        stack.push(intervals[0]);
        for (let i = 1, len = intervals.length ; i < len; i++ ) {
            last = stack[stack.length - 1];
            if (last[1] < intervals[i][0]) {
                stack.push( intervals[i] );
            }
            else if (last[1] < intervals[i][1]) {
                last[1] = intervals[i][1];

                stack.pop();
                stack.push(last);
            }
        }
      }
      return stack;
    }

    return mergeIntervals(
        timeslots
          .filter(x => x.selected)
          .map(x => [x.id, x.id+1])
      )
      .map(x => bounds[x[0]]+":00-"+bounds[x[1]]+":00")
      .join(", ");

  }

  showTerms(content) {
    this.modalService.open(content).result.then((result) => {
      this.ad.agree = (result == 'accept');
    }, (reason) => {

    });
  }

  // function that sets the Canvas size for Ad upload
  /*
  public CanvasResizing(orientation: string){
    if (orientation == 'vertical') {
      localStorage.setItem('canvas_height', '1920');
      localStorage.setItem('canvas_width', '1080');
    }
    else {
      localStorage.setItem('canvas_height', '1080');
      localStorage.setItem('canvas_width', '1920');
    }
  }
  */
 public CanvasResizing(orientation: string){
  if (orientation == 'vertical') {
    this.orientation_set = 'vertical' }
  else {
    this.orientation_set = 'horizontal' }
}

}

export class RegionDisplayParameters {
  public fillColor: any = "#ffdd4a"
  public fillOpacity: number = 0.4
  public strokeColor: any = "grey"
  public strokeOpacity: number = 0.6
}

export class RegionDisplay extends Region {
  public display: RegionDisplayParameters = new RegionDisplayParameters
  public selected: boolean = false
  private defaultParameters: RegionDisplayParameters = new RegionDisplayParameters
  private selectedParameters: RegionDisplayParameters = Object.assign({}, this.defaultParameters, {fillColor: "#23ffea"})

  public toggleSelection() {
    this.selected = !this.selected;
    if (this.selected) {
      this.display = this.selectedParameters;
    } else {
      this.display = this.defaultParameters;
    }
  }

  public isSelected() {
    return this.selected;
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/upload/upload.component.ts